import { DefaultSeoProps } from 'next-seo';

export const SEO: DefaultSeoProps = {
  titleTemplate: '%s | Thực phẩm Quảng Đà',
  defaultTitle: 'Thực phẩm Quảng Đà',
  description:
    'Thực phẩm QUẢNG ĐÀ (Quảng Đà Food) chuyên cung cấp nguyên liệu và sản phẩm cho bếp ăn công nghiệp, bếp trường học, resort, nhà hàng khách sạn.',
  canonical: 'https://thucphamquangda.com',
  openGraph: {
    type: 'website',
    locale: 'vi_VN',
    url: 'https://thucphamquangda.com',
    siteName: 'Thực phẩm Quảng Đà',
    title: 'Thực phẩm Quảng Đà',
    description:
      'Thực phẩm QUẢNG ĐÀ (Quảng Đà Food) chuyên cung cấp nguyên liệu và sản phẩm cho bếp ăn công nghiệp, bếp trường học, resort, nhà hàng khách sạn.',
    images: [
      {
        url: 'https://res.cloudinary.com/dfbbhslan/image/upload/v1754148729/Copilot_20250802_223141_x6y7hk.png',
        width: 800,
        height: 600,
        alt: 'Biệt thự sang trọng tại Đà Nẵng',
      },
    ],
  },
  twitter: {
    handle: '@thucphamquangda',
    site: '@thucphamquangda',
    cardType: 'summary_large_image',
  },
  additionalMetaTags: [
    {
      property: 'keywords',
      content:
        'Thực phẩm Quảng Đà, Chợ online, qdfood, thực phẩm sạch, thực phẩm tươi mới, cung cấp thực phẩm',
    },
  ],
  additionalLinkTags: [
    {
      rel: 'icon',
      href: '/favicon.ico',
    },
  ],
};
